import styles from './styles.module.scss';

export const TabContent = ({ id, selectedId, preload = true, children }) => {
	const active = id === selectedId;
	const mount = active || preload;
	return mount ? <div className={active ? styles.display : styles.hide}>{children}</div> : <></>;
};
